export interface DialogVariantColorConfig {
  background: { start: string; end: string };
  border: string;
  shadow: string;
}

export type DialogVariant = 'blue' | 'gold' | 'green' | 'yellow' | 'red' | 'grey';

export const variantColors: Record<DialogVariant, DialogVariantColorConfig> = {
  blue: {
    background: { start: '#D1E7F8', end: '#B8D8F0' },
    border: '#7CB5E8',
    shadow: '0 10px 40px rgba(124, 181, 232, 0.3)'
  },
  gold: {
    background: { start: '#FFF4D6', end: '#FFE8B0' },
    border: '#F4D03F',
    shadow: '0 10px 40px rgba(244, 208, 63, 0.3)'
  },
  green: {
    background: { start: '#D4F1D4', end: '#B8E6B8' },
    border: '#66D966',
    shadow: '0 10px 40px rgba(102, 217, 102, 0.3)'
  },
  yellow: {
    background: { start: '#FFF6D6', end: '#FFEEB0' },
    border: '#FFD966',
    shadow: '0 10px 40px rgba(255, 217, 102, 0.3)'
  },
  red: {
    background: { start: '#FFE0DD', end: '#FFCCC7' },
    border: '#FF9999',
    shadow: '0 10px 40px rgba(255, 153, 153, 0.3)'
  },
  grey: {
    background: { start: '#E8EAED', end: '#D5D9DD' },
    border: '#9CA3AF',
    shadow: '0 10px 40px rgba(156, 163, 175, 0.3)'
  }
};
